import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {
  user: User;

  constructor(private http: HttpClient) {
  }

  getUser() {
    return this.user;
  }

  setUser(user: User) {
    this.user = user;
  }

  createUser(user: User, campaignId: string): Observable<Object> {
    let params;

    if (campaignId) {
      params = new HttpParams().set('WT.mc_id', campaignId);
    }
    return this.http.post('/users', user, {params: params});
  }

  isEmailDuplicate(email: string): Observable<Object> {
    return this.http.get('/emailExists',
      {
        params: {
          emailAddress: email
        }
      });
  }
}
